import currencyConversion from '../../utils/currencyConversion';

export default function (number) {
  return number !== '' && !isNaN(number)
    ? '$' +
        currencyConversion
          .toDollars(number)
          .toFixed(2)
          .toString()
          .replace(/\d(?=(\d{3})+\.)/g, '$&,')
    : number;
}



// WEBPACK FOOTER //
// ./src/scheduleform/common/MoneyFormat.js